import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { Dropdown, SingleProductDownloadModal } from "components";
import { useTranslate } from "hooks";
import { NodeKinds } from "interfaces/enums";
import type { AnyProduct } from "interfaces/schemas";
import type { OrderCodeRequestSlice } from "interfaces/product/product.types";
import { Icon } from "../Icon/Icon";

import styles from "./SummaryListItem.module.scss";

interface ConfigurationItemProps {
  conf: AnyProduct;
  style?: React.CSSProperties;
}

const ConfigurationItemComponent = ({
  conf,
  style = {},
}: ConfigurationItemProps) => {
  const translate = useTranslate();
  const orderCode = "orderCode" in conf ? conf.orderCode : undefined;

  const openDownloadModal = useCallback(() => {
    NiceModal.show(SingleProductDownloadModal, {
      modalSubtitle: conf.productName ?? "",
      nodeId: conf.id,
      orderCode: (orderCode ?? undefined) as OrderCodeRequestSlice | undefined,
      presentation: conf.presentation ?? "",
    });
  }, [conf.id, conf.presentation, conf.productName, orderCode]);

  const showDownloadButton =
    conf.presentation &&
    orderCode &&
    conf.kind !== NodeKinds.TROX_NETCOM_PRODUCT &&
    conf.kind !== NodeKinds.TROX_NETCOM_NOTE &&
    conf.kind !== NodeKinds.TROX_NETCOM_GENERIC_PRODUCT &&
    conf.kind !== NodeKinds.CUSTOM_PRODUCT;

  return (
    <div
      className={cx(
        "d-flex justify-content-between align-items-center border-bottom ms-5",
        styles.item,
      )}
      style={style}
    >
      <div className="d-flex flex-column ps-2_5 mw-100">
        <div className="fw-bolder fs-mdoverflow-hidden text-truncate">
          {conf.productName ?? ""}
        </div>
        <div className="text-gray-400 overflow-hidden text-truncate">
          <span>
            {translate("PRESENTATION_ORDER_CODE")}: {conf.presentation}
          </span>{" "}
          |{" "}
          <span>
            {translate("QUANTITY")}: {conf.quantity}
          </span>
        </div>
      </div>
      {showDownloadButton && (
        <Dropdown
          btnChildren={
            <Icon
              iconName="ellipsis-vertical-regular"
              className="icon-20"
              data-testid="project-product-actions-icon"
            />
          }
          btnId="project_product_actions_icon"
          options={[
            {
              id: "download",
              title: translate("DOWNLOAD"),
              onClick: () => openDownloadModal(),
            },
          ]}
        />
      )}
    </div>
  );
};

export const ConfigurationItem = Scrivito.connect(ConfigurationItemComponent);
